import React, { useState } from "react";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useNavigate } from "react-router-dom";
import {
  errorToaster,
  successToaster,
} from "../../../helper/toasterConfiguration";
import { Styles } from "./styles";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import SubmitOfferCard from "./submit-offer-item";

const AddOrderForm = ({
  panels,
  isPanelsLoading,
  users,
  isUsersLoading,
  offers,
  isOffersLoading,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState();
  const [price, setPrice] = useState();
  const itemsPerPage = 25;

  // Panels State
  const [panelsPage, setPanelsPage] = useState(1);
  const [panelSearchQuery, setPanelSearchQuery] = useState("");
  const paginatedPanels = panels.slice(0, panelsPage * itemsPerPage);
  const filteredPanels = panels.filter((panel) =>
    panel.name.toLowerCase().includes(panelSearchQuery.toLowerCase())
  );
  const displayedPanels = panelSearchQuery ? filteredPanels : paginatedPanels;

  // Users State
  const [usersPage, setUsersPage] = useState(1);
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const paginatedUsers = users.slice(0, usersPage * itemsPerPage);
  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(userSearchQuery.toLowerCase())
  );
  const displayedUsers = userSearchQuery ? filteredUsers : paginatedUsers;

  // Offers State
  const [offersPage, setOffersPage] = useState(1);
  const [offerSearchQuery, setOfferSearchQuery] = useState("");
  const paginatedOffers = offers.slice(0, offersPage * itemsPerPage);
  const filteredOffers = offers.filter((offer) =>
    offer.title.toLowerCase().includes(offerSearchQuery.toLowerCase())
  );
  const displayedOffers = offerSearchQuery ? filteredOffers : paginatedOffers;
  const [data, setData] = useState({
    offer_id: "",
    panel_id: "",
    price: "",
    payment_method: "",
    user_id: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    setPrice(null);
  };

  const handlePanelChange = (event, value) => {
    setData((prev) => ({ ...prev, panel_id: value?.id || "" }));
  };

  const handleUserChange = (event, value) => {
    setData((prev) => ({ ...prev, user_id: value?.id || "" }));
  };

  const handleOfferChange = (event, value) => {
    setData((prev) => ({ ...prev, offer_id: value?.offer_id || "" }));
    setSelectedOffer(value);
  };

  const handleChange = (index, field, value) => {
    if (index || index == 0) {
      setData((prev) => ({
        ...prev,
        [`${field}_${index}`]: value,
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [`${field}`]: value,
      }));
    }
    console.log(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = ["offer_id", "panel_id"];

    const updatedFormData = {
      ...data,
    };

    const missingFields = requiredFields.filter(
      (field) => !updatedFormData[field]
    );
    // Validate customLogo properties for each offer detail with a picture
    selectedOffer?.offerDetails?.forEach((item, idx) => {
      if (item?.picture) {
        if (!data?.[`logoName_${++idx}`]) {
          missingFields.push(`logoName for detail ${++idx}`);
        }
      }
    });

    if (missingFields.length > 0) {
      errorToaster(
        `Please fill in all required fields: ${missingFields.join(", ")}`
      );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const form_data = new FormData();

    // Construct requests array for offer details
    const offer_details_data = [];
    selectedOffer?.offerDetails?.forEach((item, idx) => {
      const request = {};
      if (item.title || item.description || item.picture || item.priority)
        request.offer_detail_id = String(item?.id) || "";
      if (item.title) request.title = data[`title_${idx + 1}`] || "";
      if (item.description)
        request.description = data[`description_${idx + 1}`] || "";
      if (item.priority) {
        request.priority = data[`priority_${idx + 1}`] || "";
        console.log(data[`priority_${idx + 1}`]);
        console.log("index : " + (idx + 1));
      }
      if (item.picture) {
        request.customLogo = {
          fontSize: data[`fontSize_${idx + 1}`]
            ? `${data[`fontSize_${idx + 1}`]}px`
            : "30px",
          color: data[`selectedColor_${idx + 1}`] || "#FFFFFF",
          fontFamily: data[`selectedFont_${idx + 1}`] || "Mockads",
          logoName: data[`logoName_${idx + 1}`],
        };
      }
      offer_details_data.push(request);
    });
    console.log("offer : " + offer_details_data);
    Object.keys(updatedFormData).forEach((key) => {
      if (
        !key.startsWith("title_") &&
        !key.startsWith("description_") &&
        !key.startsWith("priority_") &&
        !key.startsWith("logoName_") &&
        !key.startsWith("selectedColor_") &&
        !key.startsWith("selectedFont_") &&
        !key.startsWith("fontSize_")
      ) {
        if (key === "user_id") {
          if (updatedFormData[key]) form_data.append(key, updatedFormData[key]);
        } else {
          if (key === "offer_id") {
            form_data.append(key, String(updatedFormData[key]));
          } else {
            form_data.append(key, updatedFormData[key]);
          }
        }
      }
    });

    // Append offer_details_data array to form_data
    offer_details_data.forEach((request, index) => {
      Object.keys(request).forEach((key) => {
        if (key === "customLogo") {
          Object.keys(request[key]).forEach((logoKey) => {
            form_data.append(
              `offer_details_data[${index}][customLogo][${logoKey}]`,
              request[key][logoKey]
            );
          });
        } else {
          form_data.append(
            `offer_details_data[${index}][${key}]`,
            request[key]
          );
        }
      });
    });
    const result = await Helper.Post({
      url: api_Routes.Orders.AddOfferOrder,
      data: form_data,
      hasToken: true,
    });

    const { response, message } = result || {};

    if (response) {
      successToaster(message);
      navigate("/Orders");
    }
    setIsLoading(false);
  };

  return (
    <Styles>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-y-6">
        <div className="flex flex-col justify-between items-center gap-6 md:flex-row">
          <div className="flex flex-col justify-between items-center gap-6 md:flex-row w-full">
            {/* Panels Autocomplete */}
            <div className="w-full">
              <Autocomplete
                disablePortal
                loading={isPanelsLoading}
                options={displayedPanels}
                getOptionLabel={(option) => option.name || ""}
                onChange={handlePanelChange}
                onInputChange={(event, value) => setPanelSearchQuery(value)}
                renderInput={(params) => (
                  <TextField {...params} label="Panel" variant="outlined" />
                )}
                ListboxProps={{
                  onScroll: (event) => {
                    const listboxNode = event.currentTarget;
                    if (
                      listboxNode.scrollTop + listboxNode.clientHeight >=
                      listboxNode.scrollHeight - 3
                    ) {
                      setPanelsPage((prevPage) => prevPage + 1);
                    }
                  },
                }}
              />
            </div>

            {/* Users Autocomplete */}
            <div className="w-full">
              <Autocomplete
                disablePortal
                loading={isUsersLoading}
                options={displayedUsers}
                getOptionLabel={(option) => option.name || ""}
                onChange={handleUserChange}
                onInputChange={(event, value) => setUserSearchQuery(value)}
                renderInput={(params) => (
                  <TextField {...params} label="User" variant="outlined" />
                )}
                ListboxProps={{
                  onScroll: (event) => {
                    const listboxNode = event.currentTarget;
                    if (
                      listboxNode.scrollTop + listboxNode.clientHeight >=
                      listboxNode.scrollHeight - 3
                    ) {
                      setUsersPage((prevPage) => prevPage + 1);
                    }
                  },
                }}
              />
            </div>
          </div>
        </div>
        {/* Offers Autocomplete */}
        <div className="w-full">
          <Autocomplete
            disablePortal
            loading={isOffersLoading}
            options={displayedOffers}
            getOptionLabel={(option) => option.title || ""}
            onChange={handleOfferChange}
            onInputChange={(event, value) => setOfferSearchQuery(value)}
            renderInput={(params) => (
              <TextField {...params} label="Offer" variant="outlined" />
            )}
            ListboxProps={{
              onScroll: (event) => {
                const listboxNode = event.currentTarget;
                if (
                  listboxNode.scrollTop + listboxNode.clientHeight >=
                  listboxNode.scrollHeight - 3
                ) {
                  setOffersPage((prevPage) => prevPage + 1);
                }
              },
            }}
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-x-6 md:flex-row">
          {selectedOffer && (
            <TextField
              fullWidth
              label="Price"
              name="price"
              required
              autoComplete="off"
              value={data?.price || price || ""}
              onChange={handleInputChange}
              variant="outlined"
              InputLabelProps={{
                shrink: Boolean(data?.price || price),
              }}
            />
          )}
          <FormControl className="w-full">
            <InputLabel id="payment-method-select-label">
              Payment method *
            </InputLabel>
            <Select
              labelId="payment-method-select-label"
              id="payment-method-select"
              value={data.payment_method || null}
              required
              onChange={(e) => {
                setData((prev) => ({
                  ...prev,
                  ["payment_method"]: e.target.value,
                }));
              }}
              label="Payment method"
              sx={{ textAlign: "start" }}
            >
              <MenuItem value="cryptomus">Cryptomus</MenuItem>
              <MenuItem value="payeer">Payeer</MenuItem>
            </Select>
          </FormControl>
        </div>

        {selectedOffer && (
          <Box sx={{ marginTop: "40px" }}>
            <Box>
              {selectedOffer?.offerDetails?.map((detail, index) => {
                return (
                  <SubmitOfferCard
                    index={index}
                    detail={detail}
                    formData={data}
                    handleChange={handleChange}
                  />
                );
              })}
            </Box>
          </Box>
        )}

        <div className="submit-btn">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={22} sx={{ color: "white" }} />
            ) : (
              "Submit"
            )}
          </Button>
        </div>
      </form>
    </Styles>
  );
};

export default AddOrderForm;
